import { computed, ref } from 'vue'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import useApiRequest from '@/_core/hooks/useApiRequest'
import { fetchChildVprs } from '@/services/vpr'

export default function ChildVprListController () {
  const { $emit, $on, $off } = useEventEmitter()

  // Child vpr items logic
  const items = ref([])

  const requestVprList = useApiRequest(fetchChildVprs)
  requestVprList.$on('success', () => {
    items.value = requestVprList.data.results
    $emit('requestvprresults-success', requestVprList.data.results)
  })
  requestVprList.$on('error', () => {
    $emit('requestvprresults-error', requestVprList.errors)
  })
  const childVprListRequest = async (childId) => {
    await requestVprList.request(childId)
  }

  return {
    items,
    childVprListRequest,
    isLoading: computed(() => requestVprList.isLoading),
    $on,
    $off
  }
}
